// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner {
  height: 100%;
  width: 100%;
}

.wrapper {
  position: relative;
  padding: 0 !important;
  height: 100% !important;
  width: 100% !important;
}

.wrapper > div {
  padding: 0 !important;
  width: 100%;
  height: 100% !important;
}

.wrapper > div > video {
  padding: 0 !important;
  width: 100%;
  height: 100% !important;
  object-fit: cover;
}

.overlay {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 7;
  width: 100%;
  height: 100% !important;
  top: 0;
}

.boxWrapper {
  position: absolute;
  width: 70%;
  height: auto;
  z-index: 12;
  top: 18%;
  /* bottom: 0; */
  /* right: 0; */
  left: 50%;
  transform: translateX(-50%);
  border-radius: 24px;
  aspect-ratio: 1/1;
  max-width: 28rem;
}
.boxWrapper__cornerWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
}
.boxWrapper__cornerWrapper__cornerLeftTop {
  position: absolute;
  width: 4.8rem;
  top: 0;
  left: 0;
}
.boxWrapper__cornerWrapper__cornerLeftBottom {
  position: absolute;
  width: 4.8rem;
  bottom: 0;
  left: 0;
}
.boxWrapper__cornerWrapper__cornerRightTop {
  position: absolute;
  width: 4.8rem;
  top: 0;
  right: 0;
}
.boxWrapper__cornerWrapper__cornerRightBottom {
  position: absolute;
  width: 4.8rem;
  bottom: 0;
  right: 0;
}
.boxWrapper__text {
  color: #fff;
  text-align: center;
  font-family: Outfit;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-top: 1.2rem;
}
.boxWrapper__action {
  text-align: center;
  margin-top: 3.2rem;
}
.boxWrapper__action .custom-button {
  display: inline-flex;
  width: auto;
  min-height: 4.4rem;
  height: auto;
  padding: 0 1.6rem;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #16eba6;
  font-family: "Outfit", sans-serif;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  text-decoration: underline;
  text-underline-offset: 0.4rem;
}

.img {
  width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/QrScanner/index.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,WAAA;AAFJ;;AAIA;EACI,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;AADJ;;AAGA;EACI,qBAAA;EACA,WAAA;EACA,uBAAA;AAAJ;;AAEA;EACI,qBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AACJ;;AACA;EACI,kBAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,MAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAGJ;AADI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAGR;AADQ;EACI,kBAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;AAGZ;AADQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;AAGZ;AADQ;EACI,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;AAGZ;AADQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;AAGZ;AACI;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AACR;AAEI;EACI,kBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,iCCjEK;EDkEL,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,6BAAA;AAAZ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ","sourcesContent":["@import '../../Styles/sass/variables';\n@import '../../Styles/sass/mixins';\n\n.scanner {\n    height: 100%;\n    width: 100%;\n}\n.wrapper {\n    position: relative;\n    padding: 0 !important;\n    height: 100% !important;\n    width: 100% !important;\n}\n.wrapper > div {\n    padding: 0 !important;\n    width: 100%;\n    height: 100% !important;\n}\n.wrapper > div > video {\n    padding: 0 !important;\n    width: 100%;\n    height: 100% !important;\n    object-fit: cover;\n}\n.overlay {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 7;\n    width: 100%;\n    height: 100% !important;\n    top:0;\n}\n.boxWrapper {\n    position: absolute;\n    width: 70%;\n    height: auto;\n    z-index: 12;\n    top: 18%;\n    /* bottom: 0; */\n    /* right: 0; */\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 24px;\n    aspect-ratio: 1/1;\n    max-width: 28rem;\n\n    &__cornerWrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        border-radius: 24px;\n\n        &__cornerLeftTop {\n            position: absolute;\n            width: 4.8rem;\n            top: 0;\n            left: 0;\n        }\n        &__cornerLeftBottom {\n            position: absolute;\n            width: 4.8rem;\n            bottom: 0;\n            left: 0;\n        }\n        &__cornerRightTop {\n            position: absolute;\n            width: 4.8rem;\n            top: 0;\n            right: 0;\n        }\n        &__cornerRightBottom {\n            position: absolute;\n            width: 4.8rem;\n            bottom: 0;\n            right: 0;\n        }\n    }\n\n    &__text {\n        color: #fff;\n        text-align: center;\n        font-family: Outfit;\n        font-size: 1.4rem;\n        font-style: normal;\n        font-weight: 300;\n        line-height: normal;\n        margin-top: 1.2rem;\n    }\n    // Plain text link in the old flash-icon slot, directly under the frame.\n    &__action {\n        text-align: center;\n        margin-top: 3.2rem;\n\n        .custom-button {\n            display: inline-flex;\n            width: auto;\n            min-height: 4.4rem;\n            height: auto;\n            padding: 0 1.6rem;\n            border: none;\n            border-radius: 0;\n            background: transparent;\n            color: #16eba6;\n            font-family: $secondary_font;\n            font-size: 1.8rem;\n            font-weight: 600;\n            line-height: normal;\n            white-space: nowrap;\n            text-decoration: underline;\n            text-underline-offset: 0.4rem;\n        }\n    }\n}\n.img {\n    width: 100%;\n    height: auto;\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
